import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { round } from '../../util/util';
import '../../style/DataTable.css';

const TeamStatisticsDataTable = (props) => {
  const sortTeamsData = (a, b) => {
    if (a.round === b.round) {
      return b.totalPins - a.totalPins;
    } else {
      return a.round - b.round;
    }
  };
  const getTeamStatisticsData = () => {
    let rowData = [];

    props.teamStatistics.map((matchDay) => {
      if (!matchDay.teamStatistics.length) {
        return null;
      }
      if (matchDay.teamStatistics.length) {
        for (let i = 0; i < matchDay.teamStatistics.length; i++) {
          let row = matchDay.teamStatistics[i];
          rowData.push({
            round: matchDay.roundNo,
            name: row.teamName,
            totalPins: row.totalPins,
            bestGamePins: row.bestGamePins,
            averageGamePins: round(row.averageGamePins, 1),
            classicAverage: round(row.classicAverage, 1),
            systemAverage: round(row.systemAverage, 1),
            missAverage: round(row.missAverage, 1),
            setAverage1: round(row.setAverages[0], 1),
            setAverage2: round(row.setAverages[1], 1),
            setAverage3: round(row.setAverages[2], 1),
            setAverage4: round(row.setAverages[3], 1),
            setPoints: round(row.setPoints, 1),
          });
        }
      }

      return rowData;
    });

    if (!rowData.length) {
      rowData = [{ name: '' }];
    }

    let columns = [
      {
        label: 'Voor',
        field: 'round',
      },
      {
        label: 'Võistkonna nimi',
        field: 'name',
      },
      {
        label: 'Summa kokku',
        field: 'totalPins',
      },
      {
        label: 'Parim tulemus',
        field: 'bestGamePins',
      },
      {
        label: 'Keskmine tulemus',
        field: 'averageGamePins',
      },
      {
        label: 'Klassika keskmine',
        field: 'classicAverage',
      },
      {
        label: 'Süsteemi keskmine',
        field: 'systemAverage',
      },
      {
        label: 'Keskmiselt mööda',
        field: 'missAverage',
      },
      {
        label: '1. seeria keskmine',
        field: 'setAverage1',
      },
      {
        label: '2. seeria keskmine',
        field: 'setAverage2',
      },
      {
        label: '3. seeria keskmine',
        field: 'setAverage3',
      },
      {
        label: '4. seeria keskmine',
        field: 'setAverage4',
      },
      {
        label: 'Setipunktid',
        field: 'setPoints',
      },
    ];

    return {
      columns: columns,
      rows: rowData.sort((a, b) => sortTeamsData(a, b)),
    };
  };
  const tableData = getTeamStatisticsData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default TeamStatisticsDataTable;
